<template>
  <section>
    <!--                                                        document list-->
    <b-container>
      <b-row v-for="document in documents" v-bind:key="document.id" class="mt-1">
        <b-col sm="1">
          <i class="fa fa-file-word-o fa-lg" aria-hidden="true"></i>
        </b-col>
        <b-col sm="10" class="left">
          <b-link :href="document.location" target="_blank">
            {{ document.fileName }}
          </b-link>
        </b-col>
        <b-col sm="1">
          <i class="fa fa-times fa-lg cursor-pointer" aria-hidden="true" v-on:click="deleteDocument(document.id)"></i>
        </b-col>
      </b-row>
    </b-container>
    <!--                                                        document form-->
    <div class="mt-5">
      <div v-for="number in documentNumber" v-bind:key="number" class="mt-1">
        <section v-if="isExistField(number)">
          <b-form-file
              id="input-16"
              class="documents-input"
              v-model="newDocuments[number]"
          ></b-form-file>
          <span class="input-group-btn pull-right ml-2">
                  <button type="button" class="btn btn-danger delete"
                          v-on:click="deleteDocumentField(number)"
                          v-if="documentNumber > 0"
                  ><i class="fa fa-minus"></i></button>
          </span>
        </section>
      </div>
    </div>
    <div class="mt-1">
      <section>
        <span class="documents-input">&nbsp;</span>
        <span class="input-group-btn pull-right ml-2">
            <button type="button"
                    class="btn btn-success clonspan"
                    v-on:click="addNewDocumentField()"
                    title="Добавить картинку"
            >
                <i class="fa fa-plus"></i
                ></button>
        </span>
      </section>
    </div>
  </section>
</template>

<script>


export default {
  name: "documentForm",
  props: {
    documents: {
      type: Array,
      required: true
    },
    newDocuments: {
      type: Object,
      required: true
    },
    delete: {
      type: Function,
      required: true
    },
  },

  data() {
    return {
      documentNumber: 0
    }
  },
  methods: {
    addNewDocumentField() {
      this.documentNumber ++
      this.$set(this.newDocuments, this.documentNumber,  [])
    },
    deleteDocumentField(number) {

      this.newDocuments[number] = null
      this.$forceUpdate()
    },
    deleteDocument(documentId) {
      for (let key in this.documents) {
        if (this.documents[key].id === documentId) {
          this.documents.splice(key, 1)
        }
      }
      this.delete(documentId)
    },
    isExistField(number) {
      return this.newDocuments[number] !== null
    },
  },
  computed: {

  },
  mounted() {
  },
  created() {
    
  },
}
</script>

<style scoped>
.document {
  max-height: 6em;
}
.left {
  float: left;
  text-align: left;
}
.cursor-pointer {
  cursor: pointer;
}
</style>